import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["option", "emailsBlock", "emailsInput", "continueButton"]
  }

  toggleOption() {
    const selectedOption = this.optionTargets.find(target => target.checked)

    if (selectedOption.id === "team_creation_emails") {
      this.emailsBlockTarget.classList.remove("d-none")
      this.continueButtonTarget.disabled = true
      this.continueButtonTarget.classList.add("disabled")
    } else {
      this.emailsBlockTarget.classList.add("d-none")
      this.emailsInputTarget.value = ""
      this.continueButtonTarget.disabled = false
      this.continueButtonTarget.classList.remove("disabled")
    }
  }

  changeEmailsInput() {
    // Below regex is used to validate the emails input (emails separated by commas)
    const emailsInputRegex = /^\s*[^\s@,]+@[^\s@,]+\.[^\s@,]+\s*(?:,\s*[^\s@,]+@[^\s@,]+\.[^\s@,]+\s*)*$/
    const emailsInputValue = this.emailsInputTarget.value

    if (emailsInputRegex.test(emailsInputValue)) {
      this.continueButtonTarget.disabled = false
      this.continueButtonTarget.classList.remove("disabled")
    } else {
      this.continueButtonTarget.disabled = true
      this.continueButtonTarget.classList.add("disabled")
    }
  }
}
